const DB_NAME = 'OasisWMS';
const DB_VERSION = 2;
const STORE_NAME = 'ordenes_compra_detalle';

export default {
    async openDB() {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(DB_NAME, DB_VERSION);

            request.onupgradeneeded = (event) => {
                const db = event.target.result;
                if (!db.objectStoreNames.contains(STORE_NAME)) {
                    db.createObjectStore(STORE_NAME, { keyPath: 'recepcion_id' });
                }
            };

            request.onsuccess = (event) => {
                resolve(event.target.result);
            };

            request.onerror = (event) => {
                reject('Error opening IndexedDB: ' + event.target.errorCode);
            };
        });
    },

    async saveDetails(recepcionId, details) {
        const db = await this.openDB();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(STORE_NAME, 'readwrite');
            const store = transaction.objectStore(STORE_NAME);

            const data = {
                recepcion_id: recepcionId,
                details: details,
                timestamp: new Date().getTime()
            };

            const request = store.put(data);

            request.onsuccess = () => {
                resolve(true);
            };

            request.onerror = (event) => {
                reject('Error saving to IndexedDB: ' + event.target.errorCode);
            };
        });
    },

    async getDetails(recepcionId) {
        const db = await this.openDB();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(STORE_NAME, 'readonly');
            const store = transaction.objectStore(STORE_NAME);
            const request = store.get(recepcionId);

            request.onsuccess = (event) => {
                resolve(event.target.result ? event.target.result.details : null);
            };

            request.onerror = (event) => {
                reject('Error reading from IndexedDB: ' + event.target.errorCode);
            };
        });
    },

    async clearOthers(currentRecepcionId) {
        const db = await this.openDB();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(STORE_NAME, 'readwrite');
            const store = transaction.objectStore(STORE_NAME);
            const request = store.openCursor();

            request.onsuccess = (event) => {
                const cursor = event.target.result;
                if (cursor) {
                    if (cursor.key !== currentRecepcionId) {
                        const deleteRequest = cursor.delete();
                        deleteRequest.onerror = () => {
                            console.error('Failed to delete old record:', cursor.key);
                        };
                    }
                    cursor.continue();
                } else {
                    resolve(true);
                }
            };

            request.onerror = (event) => {
                reject('Error clearing other records from IndexedDB: ' + event.target.errorCode);
            };
        });
    },

    async deleteDetails(recepcionId) {
        const db = await this.openDB();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(STORE_NAME, 'readwrite');
            const store = transaction.objectStore(STORE_NAME);
            const request = store.delete(recepcionId);
            request.onsuccess = () => resolve(true);
            request.onerror = (event) => reject('Error deleting from IndexedDB: ' + event.target.errorCode);
        });
    },

    /**
     * Mapea los detalles en crudo del Backend al formato de IndexedDB y los guarda.
     * @param {string} recepcionId 
     * @param {Array} rawDetails 
     */
    async mapAndSaveRawDetails(recepcionId, rawDetails) {
        if (!recepcionId || !Array.isArray(rawDetails) || rawDetails.length === 0) {
            return Promise.resolve(false);
        }

        const comodinObj = {
            detalle_oc_id: null,
            padre_oc_id: rawDetails[0].orden_compra_e.replaceAll("-", ""),
            sku: "T00993",
            unidad_medida: {
                id: 69,
                nombre: "Unidad",
                cantidad_unidades: 1,
                estatus: true,
                codigo_alterno: 1
            },
        };

        const arrayToIDB = [comodinObj];
        arrayToIDB.push(...rawDetails.map((ocd_item) => ({
            detalle_oc_id: ocd_item.id.replaceAll("-", ""),
            padre_oc_id: ocd_item.orden_compra_e.replaceAll("-", ""),
            sku: ocd_item.producto,
            unidad_medida: ocd_item.unidad_medida,
        })));

        await this.saveDetails(recepcionId, arrayToIDB);
        return arrayToIDB;
    }
};
